window.addEventListener("DOMContentLoaded", function () {
  document
    .querySelectorAll(".bridgman-banner-parent")
    .forEach(function (banner) {
      if (banner.classList.contains("slick-initialized")) return;

      const selector =
        ".bridgman-banner-parent-" + banner.getAttribute("data-section-id");
      const speed = parseInt(banner.getAttribute("data-swiper-speed")) * 1000;
      const campaign = new URLSearchParams(window.location.search).get(
        "campaign",
      );
      const autoplay = speed === 0 ? false : true;

      var slickConfig = {
        autoplay: autoplay,
        infinite: true,
        autoplaySpeed: speed,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        adaptiveHeight: true,
      };

      // If a campaign param is present, find the matching slide and set it as initial
      if (campaign) {
        var slides = banner.querySelectorAll(".bridgman-banner-container");
        for (var i = 0; i < slides.length; i++) {
          if (slides[i].getAttribute("data-campaign") === campaign) {
            slickConfig.initialSlide = i;
            break;
          }
        }
      }

      $(selector).slick(slickConfig);
    });
});
